import './index.scss'
$("header .nav ul li").eq(4).addClass("active");
import Swiper from 'swiper/swiper-bundle.min.js'
var use = new Swiper(".use .mySwiper", {
    slidesPerView: 4,
    spaceBetween:20,
    navigation: {
      nextEl: ".use .swiper-button-next",
      prevEl: ".use .swiper-button-prev",
    },
    breakpoints: {
        320: {
            slidesPerView: 1,
        },
        768: {  //当屏幕宽度大于等于1280
        slidesPerView: 2,
        }, 
        1020: {
            slidesPerView: 3,
        },
        1440: {  //当屏幕宽度大于等于1280
            slidesPerView: 4,
        }
    }
  });
  $(".swiper-button").click(function () {
    $(this).addClass("active").siblings().removeClass("active")
})
var effect = new Swiper(".effect .mySwiper", {
    navigation: {
      nextEl: ".effect .swiper-button-next",
      prevEl: ".effect .swiper-button-prev",
    },
  });
  $(".swiper-button").click(function () {
    $(this).addClass("active").siblings().removeClass("active")
})